// extracted by mini-css-extract-plugin
export var pni = "pni-module--pni--e3fe1";
export var searchStatusMessage = "pni-module--searchStatusMessage--9b6e5";